import { render, staticRenderFns } from "./NavigationMenuPromoGroupMobile.vue?vue&type=template&id=559170ee"
import script from "./NavigationMenuPromoGroupMobile.vue?vue&type=script&lang=js"
export * from "./NavigationMenuPromoGroupMobile.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuPromoGroupMobile.vue?vue&type=style&index=0&id=559170ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports